'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-edit.routes.js';

export class DocumentEditComponent {
  /*@ngInject*/
  constructor(dialogs, DocumentService, $stateParams, $state, $location, Config) {
    this.DocumentService = DocumentService;
    this.docId = $stateParams.id;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$location = $location;

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Document Upload");

    // Enumeration with possible document types
    this.documentType = documentConfig.getTypes();

    this.documentPageCategories = documentConfig.getPageCategories();

    this.document = {};

    this.DocumentService.get({id: this.docId}, doc => {
      this.document = doc;
    }, err => {
      console.log('Could not get the document from the server.');
    });

    this.submitted = false;
  }

  patch(form) {

    this.submitted = true;
    this.sendSuccess = false;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {
      this.DocumentService.patch({id: this.docId},[
          { op: 'replace', path: '/title', value: this.document.title },
          { op: 'replace', path: '/type', value: this.document.type },
          { op: 'replace', path: '/description', value: this.document.description },
          { op: 'replace', path: '/isPublic', value: this.document.isPublic }
        ], () => {
          this.submitted = false;
          this.sendSuccess = true;

          var dlg = this.dialogs.notify("Success", "Your document has been changed successfully");
          dlg.result.then(() => {

            let docPageType = "list";

            if (that.documentPageCategories) {
              for (let key in that.documentPageCategories) {
                if (that.documentPageCategories.hasOwnProperty(key)) {
                  if (that.documentPageCategories[key].indexOf(this.document.type) != -1) {
                    docPageType = key;
                  }
                }
              }
            }
            
            that.$location.url("/document/"+docPageType);
          });
        },
        (err) => {
          this.sendFailure = true;
        })
    }
  }
}

export default angular.module('conduuApp.documentEdit', [uiRouter])
  .config(routes)
  .component('documentEdit', {
    template: require('./document-edit.html'),
    controller: DocumentEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/edit/document-edit.component.js